/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from '@/config/backend'

export default class DashboardService {
    getDashboard(defaultDashboard) {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    '/api/' +
                        JSON.parse(localStorage.getItem('company')).id +
                        '/modules/' +
                        defaultDashboard
                )
                .then(({ data }) => resolve(data.data))
                .catch((e) => reject(e))
        })
    }
}
